module.exports = __webpack_public_path__ + "static/img/image018.f20c13a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image018.png
// module id = STgT
// module chunks = 1